import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { omit } from "lodash";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../../store/cbomSlice";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetCryptographyQuery } from "../../services/cbom.api";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import { getQueryStatus } from "../../utils";
import XbomExportActions from "../common/XbomExportActions/XbomExportActions";
import CryptoAsset from "./CryptoAsset/CryptoAsset";
import Filter from "./Filter/Filter";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "kind",
        label: "Kind",
        sortProperty: "kind",
        sortId: "cbom-sort-kind",
        startReverse: true,
        width: "125px",
    },
    {
        id: "type",
        label: "Type",
        sortProperty: "type",
        sortId: "cbom-sort-type",
        startReverse: true,
        width: "250px",
    },
    { id: "description", label: "Description", width: "100%" },
    {
        id: "issue_count",
        label: "# Issues",
        sortProperty: "issue_count",
        sortId: "cbom-sort-issue-count",
        startReverse: true,
        width: "150px",
    },
    {
        id: "component_count",
        label: "# Components",
        sortProperty: "component_count",
        sortId: "cbom-sort-component-count",
        startReverse: true,
        width: "170px",
    },
];
const CBOMContent = () => {
    var _a;
    const { reportId, diffId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { match_count: 0, crypto_assets: [] }, isLoading, isFetching, isError, error, } = useGetCryptographyQuery({
        filter,
        sort,
        pagination,
        ui_id: reportId,
    });
    const handleSortChange = (newSort) => {
        dispatch(sortUpdated(newSort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Cryptography bill of materials", details: [
                `${((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.xbom.cbom) !== null && _a !== void 0 ? _a : 0).toLocaleString()} Cryptographic assets`,
            ], actions: React.createElement(XbomExportActions, null) }),
        React.createElement(Page.Filters, { found: {
                id: "cbom-clear-all-filters",
                count: data.match_count,
                initialFilters: omit(initFilter, "item_id"),
                activeFilters: omit(filter, "item_id"),
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "cryptographic assets",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "cbom-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.crypto_assets.map((cryptoAsset, index) => (React.createElement(CryptoAsset, { key: cryptoAsset.id, cryptoAsset: cryptoAsset, rowIndex: index })))))));
};
const CBOM = () => {
    return (React.createElement(ErrorBoundary, { key: "cbom" },
        React.createElement(CBOMContent, null)));
};
export default CBOM;
//# sourceMappingURL=CBOM.js.map